import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {connect} from "react-redux";
import {Box, Badge} from "@material-ui/core";
import {CalendarToday, DirectionsCar, LocalAtm} from "@material-ui/icons";
import * as actions from "../../store/actions";
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import VehicleSelector from "../../components/UI/VehicleSelector";
import SelectedVehicleDetails from "../../components/UI/SelectedVehicleDatails";
import OfferDetailBox from "../../components/UI/OfferDetailBox";
import capitalize from "@material-ui/core/utils/capitalize";
import {DashboardStyles} from "../../styles/dashboard";
import {filterActiveOffers} from "../../store/actions/offers";
import {PanelTabs} from '../../store/actions/dashboard';
import {Link as RouterLink} from "react-router-dom";
import Link from "@material-ui/core/Link";
import AppointmentDetailBox from "../../components/UI/AppointmentDetailBox";
import Banner from "../../components/UI/Banner";

const useStyles = makeStyles(DashboardStyles);

const Settings = (props) => {

    const classes = useStyles(DashboardStyles);
    const [activeOffers, setActiveOffers] = useState(0);
    const onLoad = () => { props.onLoad() };

    useEffect(() => {
        onLoad();
    }, [true]);

    useEffect(() => {
        const value = filterActiveOffers(props.selectedVehicle ? props.selectedVehicle.offers : []).length;
        setActiveOffers(value);
    }, [props.selectedVehicle]);

    if (props.account) {
        

        const handleExpansionPanel = (e, expanded, tab) => {
            props.onUpdateTabOnly(tab, expanded);
            // props.onUpdatePanelTab(tab, expanded);
        };

        const activeAppointments = props.selectedVehicle && props.selectedVehicle.appointments ? props.selectedVehicle.appointments.length : 0;

        return (
            <Box className={classes.dashboardRoot}>
                <h1 className={classes.title}>{capitalize(props.account.firstName ?? 'Noname')}'s Dashboard</h1>
                <Banner />
                <VehicleSelector vehicles={props.vehicles}/>
                <ExpansionPanel className={[classes.dashboardItem, 'first'].join(' ')} onChange={(e, ex) => handleExpansionPanel(e, ex, PanelTabs.my_vehicle)} 
                    expanded={props.dashboard[PanelTabs.my_vehicle].expanded}>
                    <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    > 
                        <Box className={classes.expansionBox}><DirectionsCar className={classes.icon}/><span
                            className={[classes.uploadText, 'panelTitle'].join(' ')}>My Vehicle</span>
                        </Box>

                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <SelectedVehicleDetails vehicles={props.vehicles}/>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                {/* <ExpansionPanel className={classes.dashboardItem}>
                    <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel2-content"
                        id="panel2-header"
                    > <Box className={classes.expansionBox}> <Build className={classes.icon}/><span
                        className={classes.uploadText}>
                Open Recalls</span>
                    </Box>

                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.alignCenter}>
                        <Box className={classes.expansionBox, classes.width100p}>
                            Coming Soon
                        </Box>
                    </ExpansionPanelDetails>
                </ExpansionPanel> */}
                <ExpansionPanel className={classes.dashboardItem} onChange={(e, ex) => handleExpansionPanel(e, ex, PanelTabs.offers)}
                    expanded={props.dashboard[PanelTabs.offers].expanded}>
                    <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel3-content"
                        id="panel3-header"
                    > 
                    <Box className={classes.expansionBox}> 
                        <LocalAtm className={classes.icon}/>
                        <span className={[classes.uploadText, 'panelTitle'].join(' ')}>Offers</span>
                        <Box className={classes.bageBox}>
                            <Badge classes={{ badge: classes.badge }} badgeContent={activeOffers} color="primary"></Badge>
                        </Box>
                    </Box>

                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.alignCenter}>
                        <Box className={[classes.expansionBox, classes.width100p].join(' ')}>
                            <OfferDetailBox vehicle={props.selectedVehicle} />
                        </Box>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel className={[classes.dashboardItem, 'last'].join(' ')} onChange={(e, ex) => handleExpansionPanel(e, ex, PanelTabs.appointments)}
                    expanded={props.dashboard[PanelTabs.appointments].expanded}>
                    <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel3-content"
                        id="panel3-header"
                    >
                        <Box className={classes.expansionBox}>
                            <CalendarToday className={classes.icon}/>
                            <span className={[classes.uploadText, 'panelTitle'].join(' ')}>Appointments</span>
                            <Box className={classes.bageBox}>
                                <Badge classes={{ badge: classes.badge }} badgeContent={activeAppointments} color="primary"></Badge>
                            </Box>
                        </Box>

                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.alignCenter}>
                        <Box className={[classes.expansionBox, classes.width100p].join(' ')}>
                            <AppointmentDetailBox vehicle={props.selectedVehicle} />
                        </Box>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            </Box>
        );

    } else {
        return (
            <Box className={classes.box}><h1 style={{fontSize: '24px'}} className={classes.title}>Dashboard</h1></Box>)
    }

}

const mapStateToProps = state => {
    return {
        account: state.account,
        vehicles: state.vehicles,
        selectedVehicle: state.app.selectedVehicle,
        dashboard: state.dashboard
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onLoad: () => dispatch(actions.getVehicles()),
        onSetSelectedVehicle: (id) => dispatch(actions.setSelectedVehicle(id)),
        onUpdatePanelTab: (tab, expanded) => dispatch(actions.updatePanelTab(tab, expanded)),
        onUpdateTabOnly: (tab, expanded) => dispatch(actions.updateTabOnly(tab, expanded))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Settings);